import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { A } from '~/__modules__/browser';
import {
  Tooltip
} from '~/notify/settings/__modules__/component';
import { SetNotiTimeBiz } from '~/notify/settings/biz/SetNotiTimeBiz';


export function NotificationTab() {
  const { t } = useTranslation();
  const [enable, setEnable] = useState(false);

  useEffect(() => {
    SetNotiTimeBiz.getNotiTimeOptions().then((res) => {
      setEnable(res.enable);
    });
  }, [])

  return (
    <li className="item has_link">
      <div className="title_area">
        <h4 className="title">
          <span className="text">{t('noti_alert_setting')}</span>
          <Tooltip>{t('noti_main_guide6')}</Tooltip>
        </h4>
      </div>
      <span className="status">
        {enable ? t('noti_alert_usey') : t('noti_alert_usen')}
      </span>
      <A href={'/settings/set_noti_time'} className="link_more">
        <i className="blind">go to detail</i>
      </A>
    </li>
  );
}
